<div *adaptLoading="isLoading">
    @if (error) {
        <div class="alert alert-danger">
            We're sorry, but there was an issue loading the article content :(
            <br /><br />
            {{ error }}
        </div>
    }

    @if (article) {
        <div [froalaView]="article.answer"
             [disableViewCallbacks]="true"
             (contentLoaded)="onContentLoaded()"></div>
    }
</div>
